import { render } from "./BasicCard.vue?vue&type=template&id=36f6f5b7&ts=true"
import script from "./BasicCard.vue?vue&type=script&lang=ts"
export * from "./BasicCard.vue?vue&type=script&lang=ts"

import "./BasicCard.vue?vue&type=style&index=0&id=36f6f5b7&lang=css"

import exportComponent from "/home/gitlab-deployer/builds/Bp7u02vYG/0/erp/admissibles-front/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__